/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

require('./es.number.constructor-17a0e7eb.js');
var normalizeComponent = require('./normalize-component-d885d5ff.js');

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'BfDialog',
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: ''
    },
    hierarchy: {
      type: Number,
      default: 3000
    },
    onClickBody: {
      type: Function,
      default: function _default() {}
    },
    bodyClasses: {
      type: [Array, String],
      default: null
    },
    wrapperClasses: {
      type: [Array, String],
      default: null
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    width: String,
    top: {
      default: undefined
    },
    backgroundImage: {
      type: String
    },
    beforeClose: Function,
    /* dialog append to body,里面的内容使用自定义组件，否则样式要设置成全局的。
     因为在页面class下的样式不会生效，因为已经在body里了。*/
    appendToBody: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'white'
    }
  },
  data: function data() {
    return {
      closed: false
    };
  },
  computed: {
    style: function style() {
      var style = {};
      if (this.width) {
        style.width = this.width;
      }
      if (this.top !== undefined) {
        style.top = this.top;
        style.transform = 'translateX(-50%)';
        style.webkitTransform = 'translateX(-50%)';
      }
      if (this.backgroundImage) {
        style.backgroundImage = "url(".concat(this.backgroundImage, ")");
      }
      return style;
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;
      if (val) {
        this.closed = false;
        this.$emit('open');
        this.$nextTick(function () {
          _this.$refs.dialog.scrollTop = 0;
        });
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      }
    }
  },
  methods: {
    handleWrapperClick: function handleWrapperClick() {
      if (!this.closeOnClickModal) return;
      this.handleClose();
    },
    handleClose: function handleClose() {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    hide: function hide(cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('close');
        this.closed = true;
      }
    }
  },
  mounted: function mounted() {
    if (this.visible) {
      this.$emit('open');
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },
  destroyed: function destroyed() {
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { name: "dialog-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "bf-dialog__wrapper",
        class: [_vm.wrapperClasses],
        style: { "z-index": _vm.hierarchy },
        on: {
          click: function ($event) {
            if ($event.target !== $event.currentTarget) {
              return null
            }
            return _vm.handleWrapperClick.apply(null, arguments)
          },
        },
      },
      [
        _c(
          "div",
          {
            ref: "dialog",
            staticClass: "bf-dialog",
            class: [_vm.theme === "black" ? "black" : "white", _vm.bodyClasses],
            style: _vm.style,
            on: {
              click: function ($event) {
                $event.stopPropagation();
                return _vm.onClickBody.apply(null, arguments)
              },
            },
          },
          [
            _vm.showClose
              ? _c("div", {
                  staticClass: "bf-dialog__headerbtn",
                  on: { click: _vm.handleClose },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.title
              ? _c(
                  "div",
                  { staticClass: "bf-dialog__header" },
                  [
                    _vm._t("title", function () {
                      return [
                        _c("p", {
                          staticClass: "bf-dialog__title",
                          domProps: { innerHTML: _vm._s(_vm.title) },
                        }),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bf-dialog__body" },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _vm.$slots.footer
              ? _c(
                  "div",
                  { staticClass: "bf-dialog__footer" },
                  [_vm._t("footer")],
                  2
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-fc18b9a0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

exports.__vue_component__ = __vue_component__;
